import { GET_PRODUCT_TEMPLATE_SUCCESS } from './constants';

const INITIAL_STATE = {
  data: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCT_TEMPLATE_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data
      };
    }
    default:
      return state;
  }
};

export default reducer;
